import { render, staticRenderFns } from "./SelectVolunteer.vue?vue&type=template&id=8b0b7b48&scoped=true&lang=pug&"
import script from "./SelectVolunteer.vue?vue&type=script&lang=js&"
export * from "./SelectVolunteer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0b7b48",
  null
  
)

export default component.exports